// Sticky bar after hero
const hero = document.getElementById('hero');
const bar = document.getElementById('stickyBar');
if (hero && bar) addEventListener('scroll', () => {
  bar.classList.toggle('visible', scrollY > hero.offsetTop + hero.offsetHeight - 100);
}, {passive: true});

// Gallery
const thumbsEl = document.getElementById('thumbs');
if (thumbsEl) thumbsEl.addEventListener('click', e => {
  const t = e.target.closest('img[data-full]');
  if (!t) return;
  document.querySelectorAll('#thumbs img').forEach(i => i.classList.remove('active'));
  t.classList.add('active');
  document.getElementById('bbMain').src = t.dataset.full;
});

// Offer cards
document.querySelectorAll('[data-offer]').forEach(c => {
  c.addEventListener('click', () => {
    document.querySelectorAll('[data-offer]').forEach(x => x.classList.remove('selected'));
    c.classList.add('selected');
  });
});